import { combineReducers } from 'redux'
import authRegisterReducer from './features/auth/authSlice'
import authLoginReducer from './features/auth/authLoginSlice'
import postContactReducer from './features/contact/contactSlice'
import propertyGetReducer from './features/property/propertySlice'
import allInspectionReducer from './features/inspection/inspectionSlice'

const rootReducer = combineReducers({
	authRegister: authRegisterReducer,
	authLogin: authLoginReducer,
	postContact: postContactReducer,

	propertyGetTypes: propertyGetReducer,
	allInspection: allInspectionReducer,
})

export default rootReducer
